module.exports = __webpack_public_path__ + "static/media/picto-options.2fb1ea92.svg";